import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { i18n } = useTranslation();
  const isEng = Boolean(i18n?.language?.startsWith('en'));

  useEffect(() => {
    const hasAccepted = localStorage.getItem('motorush_cookies_accepted');
    if (!hasAccepted) {
      // Delay showing banner slightly for better UX
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('motorush_cookies_accepted', 'true');
    setIsVisible(false);
  };

  const handleLinkClick = () => {
    window.location.hash = 'cookies';
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fadeIn">
      <div className="max-w-5xl mx-auto bg-gray-900 text-white rounded-2xl shadow-2xl p-5 md:p-6 flex flex-col md:flex-row items-center justify-between gap-4 border border-gray-700">
        
        <div className="flex items-center gap-4 text-sm md:text-base">
          <div className="hidden sm:flex p-3 bg-gray-800 rounded-full text-[#FF6B35]">
            <Cookie size={24} />
          </div>
          <div>
            <p className="text-gray-300">
              {isEng 
                ? "This site uses cookies to ensure you get the best experience." 
                : "Este site utiliza cookies essenciais para o funcionamento da plataforma e cookies analíticos para melhorar a sua experiência."}
              <button 
                onClick={handleLinkClick}
                className="ml-2 text-[#FF6B35] hover:text-white underline underline-offset-2 transition-colors font-semibold"
              >
                {isEng ? "Learn more" : "Saber mais"}
              </button>
            </p>
          </div>
        </div>

        <div className="flex w-full md:w-auto items-center gap-3 shrink-0">
          <button 
            onClick={handleAccept}
            className="w-full md:w-auto bg-[#FF6B35] hover:bg-[#e55a2b] text-white px-8 py-2.5 rounded-xl font-bold transition-all shadow-lg hover:shadow-orange-900"
          >
            {isEng ? "Accept" : "Aceitar e Fechar"}
          </button>
          <button 
            onClick={() => setIsVisible(false)}
            className="p-2.5 text-gray-400 hover:text-white hover:bg-gray-800 rounded-xl transition-colors md:hidden"
          >
            <X size={20} />
          </button>
        </div>

      </div>
    </div>
  );
};

export default CookieBanner;
